import {Component, OnInit} from '@angular/core';
import {ImportTemplateSubtype} from "@app/solution-manager/data-import/data-import";
import {
  CommonTransformationService,
  DateService,
  DialogStyle40,
  FileService,
  Format,
  GrowlType,
  PrimeNgConfig,
  PrimeNgSupportService,
  TableColumn,
  TableFormat,
  Validation,
  YearRange
} from "@app/shared";
import * as XLSX from "xlsx";
import {WorkSheet} from "xlsx";
import {InvoiceImportItem} from "@app/shared/classes/dataimport/invoice-import-item";
import {plainToClass} from "class-transformer";
import {ImportDataService} from "@app/shared/import/data-import/import-data.service";
import {ConfirmationService, SelectItem} from "primeng/api";
import {GrowlService} from "@app/core";

@Component({
  selector: 'app-invoice-import-items',
  templateUrl: './invoice-import-items.component.html',
  styleUrls: ['./invoice-import-items.component.css']
})
export class InvoiceImportItemsComponent implements OnInit {

  Format: typeof Format = Format;
  PrimeNgConfig = PrimeNgConfig;
  Validation: typeof Validation = Validation;

  tableColumns: TableColumn[];
  importCells: InvoiceImportItem[] = []
  vendorDropDown: SelectItem[] = [];



  displayPartialImportDialog: boolean;
  partialImportStartDate: string;
  partialImportEndDate: string;
  partialImportVendor: string;

  yearRange = YearRange;
  DialogStyle40 = DialogStyle40;

  constructor(private importService: ImportDataService,
              private primeNgService: PrimeNgSupportService,  private fileService: FileService, private dateService: DateService,
              private transformationService: CommonTransformationService,
              private confirmationService: ConfirmationService,
              private growl: GrowlService) { }

  ngOnInit(): void {
    this.buildTableColumns();
    this.getImportData();
  }

  getImportData() {
    this.importService.getImportCells().subscribe(res => {
      this.importCells = res;
      this.buildDropDown();
    });
  }

  onClickDownloadExcelTemplate(): void {
    this.fileService.getImportTemplateThenSave(ImportTemplateSubtype.VendorInvoiceImport);
  }

  buildDropDown(){
    let validVendors: string[] = Array.from(new Set(this.importCells?.map(c => c.vendorIdentifier)));
    this.vendorDropDown = this.transformationService.convertArrayToDropDown(validVendors)
  }



  buildTableColumns() {
    this.tableColumns = [
      {field: 'invoiceDate', header: 'Invoice Date', format: TableFormat.Date},
      {field: 'vendorIdentifier', header: 'Vendor'},
      {field: 'invoiceNumber', header: 'Invoice Number'},
      {field: 'chrgIdentifier', header: 'Charge Code Identifier'},
      {field: 'itemIdentifier', header: 'Item Identifier'},
      {field: 'expenseMemo', header: 'Memo'},
      {field: 'expenseAmount', header: 'Amount', format: TableFormat.Currency},
      {field: 'expenseAccount', header: 'Ledger Account'},
    ];
  }

  onSelectConvertToInvoices(worksheet: WorkSheet): void {
    // this.journalEntryHasError = false;
    let cellsToBeImported: InvoiceImportItem[] = [];
    let timesheetCells = plainToClass(InvoiceImportItem, XLSX.utils.sheet_to_json(worksheet, {raw: true, dateNF: "YYYY-MM-DD"}));
    for (let item of timesheetCells) {
      if (!item.chrgIdentifier || !item.vendorIdentifier
        || !item.itemIdentifier || !item.expenseAmount || !item.invoiceDate) {
        continue;
      }
      cellsToBeImported.push(item);
    }

    if (cellsToBeImported?.length >= 1) {
      this.confirmationService.confirm({
        message: `Are you sure you want to import ${cellsToBeImported?.length} cells?`,
        header: 'Import Invoice Item Sheet Data',
        key: 'vendorInvoiceImport',
        icon: 'fa fa-warning',
        accept: () => {
          this.importService.saveImportCells(cellsToBeImported).subscribe(res => {
            this.getImportData();
            this.growl.add(GrowlType.Success, "Invoice Items imported successfully");
          });
        },
        reject: () => {
          this.growl.add(GrowlType.Info, "Excel import cancelled");
        }
      });
    }
  }

  onClickOpenPartialImport() {
    this.displayPartialImportDialog = true;
  }

  onClickCancelPartialImportVendorInvoices() {
    this.displayPartialImportDialog = false;
  }

  onClickPartialImportVendors(){
    this.importService.importVendorInvoices(this.partialImportStartDate, this.partialImportEndDate, this.partialImportVendor).subscribe(res => {
      this.growl.add(GrowlType.Success, "Invoices Imported successfully");
    });
  }

}
